import { render } from "./Recaptcha.vue?vue&type=template&id=696d2f65&ts=true"
import script from "./Recaptcha.vue?vue&type=script&lang=ts"
export * from "./Recaptcha.vue?vue&type=script&lang=ts"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__